module.exports = __webpack_public_path__ + "static/media/logo.f4674cfb.png";


//////////////////
// WEBPACK FOOTER
// ./src/header/logo.png
// module id = 350
// module chunks = 0